import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import PaymentsPage from '@pages/payments/PaymentsPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// const Shifts = lazy(() => import('@pages/Shifts').then((m) => ({ default: m.Shifts })));

// Route Component
const PaymentsRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('payments-page-title')}>
        {/* <div>PaymentsPage</div> */}
        <PaymentsPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  PaymentsRoute,
};
